"use client";
import { useEffect, useState } from "react";

export default function AdminDashboard() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch("https://api.alshakilee.com/api/measurements")
      .then((res) => res.json())
      .then((json) => {
        setData(json);
        setLoading(false);
      })
      .catch((err) => console.error("Error fetching measurements:", err));
  }, []);

  return (
    <div className="min-h-screen bg-slate-50 p-4 md:p-10 font-sans">
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <h1 className="text-2xl font-bold text-slate-800">Alshakilee Measurement Logs</h1>
          <button 
            onClick={() => window.location.reload()} 
            className="px-4 py-2 bg-black text-white rounded-md text-sm"
          >
            Refresh Data
          </button>
        </div>

        {loading ? (
          <p>Loading records...</p>
        ) : (
          <div className="bg-white rounded-xl shadow-sm border border-slate-200 overflow-hidden">
            <table className="w-full text-left border-collapse">
              <thead>
                <tr className="bg-slate-50 border-b border-slate-200 text-slate-500 text-sm uppercase tracking-wider">
                  <th className="p-4 font-semibold">ID</th>
                  <th className="p-4 font-semibold">Customer</th>
                  <th className="p-4 font-semibold">Phone</th>
                  <th className="p-4 font-semibold text-center">Shoulder</th>
                  <th className="p-4 font-semibold text-center">Chest</th>
                  <th className="p-4 font-semibold text-center">Waist</th>
                  <th className="p-4 font-semibold text-center">Length</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {data.map((item: any) => (
                  <tr key={item.id} className="hover:bg-slate-50 transition-colors">
                    <td className="p-4 text-slate-400 text-sm">#{item.id}</td>
                    <td className="p-4 font-medium text-slate-900">{item.customer_name}</td>
                    <td className="p-4 text-slate-600">{item.phone_number}</td>
                    <td className="p-4 text-center">{item.shoulder}"</td>
                    <td className="p-4 text-center">{item.chest}"</td>
                    <td className="p-4 text-center">{item.waist}"</td>
                    <td className="p-4 text-center">{item.length}"</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
}